import { useParams } from 'react-router';

import { bridge } from 'bridge';

import useI18next from 'services/i18n';

import { Error as ErrorPage } from './components/Error/Error';
import styles from './FakeDoor.module.scss';
import { useFakeDoor } from './useFakeDoor';

const METHOD_NAME = 'fakeDoorCTAclick';

export const FakeDoorModule = () => {
    const { featureId } = useParams<{ featureId: string }>();
    const { isTranslationsLoaded } = useI18next();

    const fakeDoor = useFakeDoor(featureId);

    if (!isTranslationsLoaded || !fakeDoor) {
        return <ErrorPage />;
    }

    const handleNotifyMe = () => {
        if (!featureId) {
            return;
        }

        bridge.send(METHOD_NAME, { featureId });
    };

    return (
        <main className={styles.wrapper}>
            <h1>{fakeDoor?.title}</h1>
            <p>{fakeDoor?.description}</p>
            <button type="button" onClick={handleNotifyMe} className={styles.button}>
                {fakeDoor?.button}
            </button>
        </main>
    );
};
